import { useLazyClinicChildren } from 'infrastructure/hooks/clinic/use-lazy-admin-clinic-list';
import CollapseAnimation from 'components/atoms/base-animations/collapse';

import s from './cols/styles.module.scss';
import { LoadingRow } from './loadingRow';
import { Rows } from './rows';

import type { Clinic } from 'infrastructure/classes/clinic';

export const ParentRow = ({
  data,
  isExpanded,
  onExpand,
}: {
  data: Clinic;
  isExpanded: boolean;
  onExpand: () => void;
}) => {
  const { clinics, trigger, loading } = useLazyClinicChildren(data.guid, false);

  const handleExpand = () => {
    if (!isExpanded) {
      trigger();
    }
    onExpand();
  };

  return (
    <>
      <Rows data={data} onExpand={handleExpand} isExpanded={isExpanded} />
      <CollapseAnimation opened={isExpanded}>
        {loading ? (
          <LoadingRow />
        ) : (
          clinics?.map((child) => (
            <div className={s['child-row-wrapper']} key={child.guid}>
              <Rows data={child} />
            </div>
          ))
        )}
      </CollapseAnimation>
    </>
  );
};
